export default __webpack_public_path__ + "static/media/ticker_collab_match.7fed0fe9.svg";